import * as React from 'react'
import { bindUpdate } from 'src/3rds/cube-react'

import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import { makeStyles } from 'tss-react/mui'
import { ResetPasswordScope } from '../Main.scopes'
import { BaseSigninView } from './components/BaseSigninPage'

export type ResetPasswordViewProps = {
    className?: string
    scope: ResetPasswordScope
}

const useStyles = makeStyles()(() => ({
    welcomeTitle: {
        fontSize: '1.9rem',
        fontWeight: 700
    },
    welcomeSubtitle: {
        fontSize: '0.95rem',
        color: '#666'
    },
    formCard: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        boxShadow: 'none',
        background: 'transparent'
    },
    fieldGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8
    },

    fieldLabel: {
        fontSize: '0.9rem',
        fontWeight: 500,
        color: '#000'
    },

    textField: {
        width: '100%',
        '& .MuiFilledInput-root': {
            backgroundColor: '#F0F3F7 !important',
            borderRadius: 8,
            border: '1px solid #E0E3E8',
            padding: '0 16px',
            height: 50,

            '&:hover': {
                backgroundColor: '#E8ECF1 !important'
            },

            '&::before, &::after': { display: 'none' }
        },

        '& .MuiInputBase-input': {
            padding: 0
        },

        '& .Mui-focused .MuiFilledInput-root': {
            border: `1px solid #00E300`
        }
    },
    mainButton: {
        backgroundColor: '#000 !important',
        color: '#fff',
        fontSize: '1rem',
        height: 50,
        borderRadius: 8,
        fontWeight: 600,
        '&:hover': {
            backgroundColor: '#111'
        }
    }
}))

export function ResetPasswordView({ className, scope }: ResetPasswordViewProps) {
    bindUpdate(React, scope)

    const { classes } = useStyles()

    const handleEmailChanged = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => (scope.email = e.target.value),
        [scope]
    )

    return (
        <BaseSigninView className={className}>
            <Typography className={classes.welcomeTitle}>Recuperar senha</Typography>
            <Typography className={classes.welcomeSubtitle}>Insira seu email para recuperar sua senha.</Typography>

            <Card className={classes.formCard}>
                <div className={classes.fieldGroup}>
                    <Typography variant="h1" className={classes.fieldLabel}>
                        Email
                    </Typography>
                    <TextField
                        variant="filled"
                        placeholder="voce@empresa.com.br"
                        className={classes.textField}
                        helperText={scope.emailError}
                        error={!!scope.emailError}
                        onChange={handleEmailChanged}
                    />
                </div>

                <Button variant="contained" onClick={scope.onResetPassword} className={classes.mainButton}>
                    Recuperar senha
                </Button>
                <Button variant="text" onClick={scope.onBackToLogin}>
                    Voltar ao login
                </Button>
            </Card>
        </BaseSigninView>
    )
}
